import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const Home = (resolve) => require(["@/views/home/index"], resolve);
const Article = (resolve) => require(["@/views/article/index"], resolve);
const Jewelry = (resolve) => require(["@/views/jewelry/index"], resolve);
const Member = (resolve) => require(["@/views/member/index"], resolve);

// 占星首页
const indexRouter = [
  {
    path: "/home",
    name: "home",
    component: Home,
    redirect: "/home/openGame",
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "openGame",
        name: "openGame",
        component: () => import("../views/home/openGame/openGame.vue"),
      },
      {
        path: "infoForm/:order_id/:product_id",
        name: "infoForm",
        component: () => import("../views/home/infoForm/infoForm.vue"),
        meta: {
          title: "占星信息",
          hideFooter: true,
        },
      },
      {
        path: "otherTable",
        name: "otherTable",
        component: () => import("../views/home/otherTable/otherTable.vue"),
        meta: {
          hideFooter: true,
          title: "宫位信息"
        }
      },
      {
        path: "luckyStone",
        name: "luckyStone",
        component: () => import("../views/home/luckyStone/luckyStone.vue"),
        meta: {
          hideFooter: true,
          title: "幸运物推荐"
        }
      },
    ],
  },
];

// 文章列表
const articleRouter = [
  {
    path: "/article",
    name: "article",
    component: Article,
    meta: {
      title: "文章列表",
    },
  },
];

// 我的
const memberRouter = [
  {
    path: "/member",
    name: "member",
    component: Member,
    redirect: "/member/index",
    meta: {
      title: "我的",
    },
    children: [
      {
        path: "index",
        name: "memberIndex",
        component: () => import("../views/member/member/index.vue"),
      },
      {
        path: "ordinaryAnalysis/:order_id",
        name: "ordinaryAnalysis",
        component: () => import("../views/member/ordinaryAnalysis/ordinaryAnalysis.vue"),
        meta: {
          hideFooter: true,
          title: "本命盘解析"
        }
      },
      {
        path: "loveMatch/:order_id",
        name: "loveMatch",
        component: () => import("../views/member/loveMatch/loveMatch.vue"),
        meta: {
          hideFooter: true,
          title: "恋爱匹配"
        }
      },
      {
        path: "selectFun",
        name: "selectFun",
        component: () => import("../views/member/selectFun/selectFun.vue"),
        meta: {
          title: "功能选择",
          // hideFooter: true,
        },
      },
      {
        path: "introAuthor",
        name: "introAuthor",
        component: () => import("../views/member/introAuthor/introAuthor.vue"),
        meta: {
          hideFooter: true,
          title: "联系summer"
        }
      },
    ],
  },
];

// 珠宝
const jewelryRouter = [
  {
    path: "/jewelry",
    name: "jewelry",
    component: Jewelry,
    redirect: "/jewelry/index",
    meta: {
      title: "珠宝",
    },
    children: [
      {
        path: "index",
        name: "jewelryIndex",
        component: () => import("../views/jewelry/list/index.vue"),
        meta: {
          title: "吠陀珠宝",
        },
      },
      {
        path: "detail/:folderIndex",
        name: "jewelryDetail",
        component: () => import("../views/jewelry/detail/index.vue"),
        meta: {
          title: "珠宝详情",
          hideFooter: true,
        },
      },
    ],
  },
];

const routes = [
  {
    path: "/",
    name: "",
    redirect: "/member/selectFun",
  },
  ...indexRouter,
  ...articleRouter,
  ...memberRouter,
  ...jewelryRouter
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
